import React from "react";
import "./about.css";
import AboutImg from "../../assets/about.jpg";

const About = () => {
  return (
    <section className="about section" id="about">
      <span className="section__eyebrow">What I Do</span>
      <h2 className="section__title">About Me</h2>

      <div className="about__container container grid">
        <img src={AboutImg} alt="" className="about__img" />
        <div className="about__data">
<ul className="about__list">
            <li>I diagnose exactly where technology is costing you time and money — then build the fix</li>
            <li>Chasing approvals over text… that's a systems problem, not a people problem</li>
            <li>Most businesses lose 20–30% of their capacity, I help them dig it out</li>
            <li>AI agents, workflow automations, ERP integrations, custom full-stack development</li>
            <li>No bloated projects. No six-month timelines. Just working systems, fast.</li>
            <li>Enterprise Consulting background with hands on and business first solutions</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
